module.exports = __webpack_public_path__ + "static/media/veggie animal 1.a03d508a.jpg";